import { render, staticRenderFns } from "./RelayInfo.vue?vue&type=template&id=51b10f6f&"
import script from "./RelayInfo.vue?vue&type=script&lang=ts&"
export * from "./RelayInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports